<template>
  <section class="welcome">
    <b-row class="my-header-container">
      <b-col>
        <div v-if="hasSlot('product')" class="product-container-top">
          <div class="product"><slot name="product"></slot></div>
        </div>
        <h2 v-if="hasSlot('default')" class="title"><slot></slot></h2>
        <div v-if="hasSlot('subtitle')" class="subtitle"><slot name="subtitle"></slot></div>
        <div v-if="hasSlot('product')" class="product-container-middle">
          <div class="product"><slot name="product"></slot></div>
        </div>
        <hr v-if="hr">
        <div v-if="hasSlot('content')" class="content"><slot name="content"></slot></div>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'StepTitle',
  props: {
    hr: {
      type: Boolean,
      default: function() {
        return false
      }
    }
  },
  computed: {
    ...mapState(['session'])
  },
  methods: {
    hasSlot: function(name) {
      return this.$slots && this.$slots[name] && this.$slots[name].length
    }
  }
}
</script>
<style scoped>
</style>
